import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { InfoRounded } from "@mui/icons-material";

import { LinkBlock } from "commons";
import { convertToMoney } from "commons/src/Money";
import { isFailure, IN_PROGRESS } from "commons/src/helpers/RequestHelpers";

import { errorStyles } from "../../helpers/ErrorHelpers";
import { requestObject } from "../../reducers/requestsActions";
import { AccountLink, CaretIcon, PlainList, Highlight, Value } from "./components";
import { routes } from "../../helpers/RouteHelpers";

export function MemoAssetsBlock({ value, requestStatus = { status: IN_PROGRESS } }) {
    const convertedValue = convertToMoney(value);

    return (
        <AccountLink to={routes.client.memoAssets()} data-testid="memo-assets-link">
            <LinkBlock>
                <Content>
                    {isFailure(requestStatus.status) && (
                        <Error>
                            <InfoRounded fontSize="small" />
                            <Message data-testid="memo-assets-error-message">
                                There was a problem fetching your memo assets. <br />
                                Click for more details.
                            </Message>
                        </Error>
                    )}

                    {!isFailure(requestStatus.status) && (
                        <>
                            <PlainList>
                                <Highlight data-testid="memo-assets-block-label">
                                    Memo Assets
                                </Highlight>
                            </PlainList>
                            <PlainList>
                                <Value data-testid="memo-assets-block-value">
                                    {convertedValue}
                                </Value>
                            </PlainList>
                        </>
                    )}
                </Content>
                <CaretIcon />
            </LinkBlock>
        </AccountLink>
    );
}

MemoAssetsBlock.propTypes = {
    value: PropTypes.number,
    requestStatus: requestObject
};

const Message = styled.span`
    margin-left: 0.5rem;
`;

const Error = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
    width: 100%;
    color: ${errorStyles.ERROR.color};
    border: 1px solid ${errorStyles.ERROR.color};
    padding: 0.5rem;
`;

const Content = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
`;
